export const useFocusTrap = (
  modalRef: Ref<HTMLElement | null>,
  isOpen: Ref<boolean>,
  onEscape?: () => void,
) => {
  const FOCUSABLE_SELECTORS =
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

  const getInertElements = (): HTMLElement[] => {
    const elements: HTMLElement[] = []
    const main = document.querySelector('main')
    const footer = document.querySelector('footer')
    if (main) elements.push(main)
    if (footer) elements.push(footer)
    return elements
  }

  const setInert = (inert: boolean) => {
    getInertElements().forEach((el) => {
      if (inert) {
        el.setAttribute('inert', '')
      } else {
        el.removeAttribute('inert')
      }
    })
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (!isOpen.value || !modalRef.value) return

    if (e.key === 'Escape' && onEscape) {
      onEscape()
      e.preventDefault()
      return
    }

    if (e.key === 'Tab') {
      const focusables =
        modalRef.value.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS)

      if (focusables.length === 0) {
        e.preventDefault()
        return
      }

      const firstFocusable = focusables[0]
      const lastFocusable = focusables[focusables.length - 1]
      const isInsideModal = modalRef.value.contains(document.activeElement)

      if (!isInsideModal) {
        e.preventDefault()
        firstFocusable?.focus()
        return
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable?.focus()
          e.preventDefault()
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable?.focus()
          e.preventDefault()
        }
      }
    }
  }

  watch(isOpen, (newVal) => {
    if (newVal) {
      setInert(true)
      window.addEventListener('keydown', handleKeyDown)
    } else {
      setInert(false)
      window.removeEventListener('keydown', handleKeyDown)
    }
  })

  onUnmounted(() => {
    setInert(false)
    window.removeEventListener('keydown', handleKeyDown)
  })
}
